








import { Component, Prop, Vue } from 'vue-property-decorator';
import { ChargeComponent } from '@/dto/subscription/SublimeChargeDTO';
import SubscriptionService from '@/services/SubscriptionService';
import { processError } from '@/utils/ComponentUtils';
import { IEmployment } from '@/dto/payroll/IEmployment';
import EmploymentTimesheetGrants from './EmploymentTimesheetGrants.vue';
import ActivePlanComponentDTO from '@/dto/employment/ActivePlanComponentDTO';
import Application from "@/state/Application";
import PortalCollapse from "@/components/request/w9cr/PortalCollapse.vue";

@Component({
  components: {
    PortalCollapse,
    EmploymentTimesheetGrants
  }
})
export default class EmploymentGrantsView extends Vue {
  @Prop({ required: true }) employment!: IEmployment;
  @Prop({ required: true }) components!: Array<ChargeComponent>;

  private activeComponents: Array<ActivePlanComponentDTO> = [];
  private loading = false;

  mounted(): void {
    this.checkActiveComponents();
  }

  private checkActiveComponents(): void {
    if (!this.components?.length) return;

    Application.startLoading();
    const promises = this.components.map(component =>
      SubscriptionService.getActiveComponent(this.employment.employer.id, component)
        .then(response => response.data)
        .catch(err => {
          processError(err, this);
          return null;
        })
    );

    Promise.all(promises).then(results => {
      this.activeComponents = results.filter(component => component && component !== null) as Array<ActivePlanComponentDTO>;
      console.log(this.activeComponents);
      Application.stopLoading();
    });
  }

  private get hasActiveComponent(): boolean {
    return this.activeComponents.length > 0;
  }
}
